import api, { Notifiable } from './api';

export interface ReportCapexManeger {
    numeroIniciativasDoAno: number;
    capexTotalDoAno: number;
    capexTotalDoAnoFormat: string;

    realizadoDoAnoAteOMesAnterios: number;
    realizadoDoAnoAteOMesAnteriosFormat: string;

    balance: number;
    balanceFormat: string;

    totalContratado: number;
    totalExecutado: number;
    totalRequisitado: number;

    totalContratadoFormat: string;
    totalExecutadoFormat: string;
    totalRequisitadoFormat: string;


    ContratadoMaisRequisitado: number;
    contratadoMaisRequisitadoFormt: number;

    totalCapex: number;

    listReportCapexManegerDiretoria: ReportCapexManegerDiretoria[];

    orcado: number;
    orcadoFormat: string
    collunBMaisCDivididoPorA: string;
    collunDDivididoPorA: string;
    naoPrevisto: number;

    totalExecutadoGrafico: number;
    totalRequisitadoGrafico: number;
    totalContratadoTotalRequisitadoGrafico: number;
    contratadoMaisRequisitado: null;

    totalizadorOrcado: string;
    totalizadorRequistiado: string;
    totalizadorForcast: string;
    totalizadorExecutado: string;
    totalizadorContratado: string;
    totalizadorNaoPrevisto: string;
}

export interface ReportCapexManegerDiretoria {
    sigla: string;

    contratado: number;
    requistiado: number;
    executado: number;
    forcast: number;

    contratadoFormat: string;
    requistiadoFormat: string;
    executadoFormat: string;
    forcastFormat: string;
    ader: string;
    collunBMaisCDivididoPorA: string;
    collunDDivididoPorA: string;
}


export interface ReportCicloOrcamentario {
    ano: number;
    colluns: CollunTable[];
    resultTable: ResultTable[];
    categories: string[];
    series: Series[];
    title: string;

    serieDataExecutado: number[];
    serieDataOrcado: number[];
    serieDataForeCast: number[];


    serieDataExecutadoLinha: number[];
    serieDataOrcadoLinha: number[];
    serieDataForeCastLinha: number[];


    serieDataExecutadoMax: number;
    serieDataOrcadoMax: number;
    serieDataForeCastMax: number;


    serieDataExecutadoLinhaMax: number;
    serieDataOrcadoLinhaMax: number;
    serieDataForeCastLinhaMax: number;
}

export interface CollunTable {
    title: string;
    dataIndex: string;

}


export interface ResultTable {
    janeiro: string,
    abril: string,
    agosto: string,
    descricao: string,
    dezembro: string,
    fevereiro: string,
    id: string

    julho: string,
    junho: string,
    maio: string,
    março: string,
    novembro: string,
    outubro: string,
    setembro: string,
}

export interface Series {
    type: string;
    name: string;
    data: number[];
}


export const getReportCapexManeger = () => api.get<ReportCapexManeger>(`relatorioCicloOrcamentario/getReportCapexManeger`);
export const getReportCurvaEconomica = () => api.get<ReportCicloOrcamentario>(`relatorioCicloOrcamentario/getReportCurvaEconomica`);




export const getAllRequisitadoAno = () => api.get<ReportCapexManeger>(`relatorioCicloOrcamentario/getAllReportCapexManeger`);
export const getAllReportCicloOrcamentario = () => api.get<ReportCicloOrcamentario>(`relatorioCicloOrcamentario/getAllReportCicloOrcamentario`);


export const GraficoEconomicoCicloAnualProjeto = (id: any) => {
    return api.get<ReportCicloOrcamentario>(`relatorioCicloOrcamentario/getAllReportCurvaEconomicoCicloAnualProjeto/${id}`);
}

export const GraficoEconomicoPlureAnualProjeto = (id: any) => {
    return api.get<ReportCicloOrcamentario>(`relatorioCicloOrcamentario/getAllReportCurvaEconomicoCicloPluriAnualProjeto/${id}`);
}